import React from "react";
import { connect } from "react-redux";
import { Button } from 'react-bootstrap';
import { useFieldArray, useFormContext } from 'react-hook-form';

import SingleConditionInputSection from './SingleConditionInputSection';
import moment from 'moment';

const SegmentConditionGroupsInputSection = () => {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'conditionGroups',
  });


  return (
    <>
      {fields
        ? fields?.map(
            (field, index) => (
              <SingleConditionInputSection
                key={field.pk || field.temporaryPk}
                index={index}
                removeConditionGroups={remove}
              />
            )
          )
        : null}
      <Button
        onClick={() => {
          append({ conditions: [], temporaryPk: moment().toISOString() });
        }}
        className="btn-back-button-common add-sub-category-btn"
      >
        + Add Condition Group
      </Button>
    </>
  );
}

const mapPropsToState = () => ({
});

export default  connect(mapPropsToState)(SegmentConditionGroupsInputSection);